import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { api } from "api/task";

import { useAuthContext } from "providers/Auth";
import { PaginatedResponse } from "shared/types";
import { GetTasksParams, Task } from "../types";

type UseTasksOptions = {
  params: GetTasksParams;
};

export const useTasks = ({ params }: UseTasksOptions) => {
  const { type } = useAuthContext();

  const query = useQuery<PaginatedResponse<Task>>({
    queryKey: ["TASKS_TABLE", params],
    queryFn: () => api.getTasks(params),
    placeholderData: keepPreviousData,
    enabled: type.isBoomCRM || type.isBoomScreen
  });

  return query;
};
